<template>
    <el-row id="collection">
        <collectionBar :tags="tags" :subTitle="subTitle" :btnSave="true" :btnBack="true" @btnSaveClick="btnSaveClick"
            @btnBackClick="btnBackClick" />
        <el-card>
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则1
                            </el-tag>
                            <span style="color: #59a8f9;">【周】理论销售校验（批号）</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.week1_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        填写本周批次库存数量后，按照计算公式(周理论销售 = 期初[上周CRM填写数量，无填写默认为0] + 期间采购[BI获取的区间段内数据之和] - 期末[本周CRM填写数量]
                        )，如果计算出的周理论销量 < 0，判断为异常数据 </div>
                </el-col>
                <el-col :span="24" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定期初(上周)的填写任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.week1_value_1" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则2
                            </el-tag>
                            <span style="color: #59a8f9;">【周】周累计销售异常校验(批号)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.week2_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        CRM中填写月度第三周及后续的周批次库存数据后，按照计算公式(周理论销售 = 期初[月度第一周CRM填写数量,无填写默认为0] + 期间采购[BI获取的区间段内数据之和] -
                        期末[本周CRM填写数量] )，如果计算出的周理论销量< 0，判断为异常数据 </div>
                </el-col>
                <el-col :span="24" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定期初(上周)的填写任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.week2_value_1" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>

        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则3
                            </el-tag>
                            <span style="color: #59a8f9;">【周】四分位法识别异常值校验(批号)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.week3_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        对应项目的第2周开始每周校验,根据BI中本周前所有周的数据之和，计算出四分位的极值(使用QUARTILE函数进行计算)当周填写数量超过该值的数据，判断为异常数据(基础数据取B/销量sale
                        order_gty值); 仅做极大值异常校验,结构保留极大及极小
                    </div>
                </el-col>
                <el-col :span="24" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定极值计算日期
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-date-picker v-model="ruleInfo.week3_value_1" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-col>
                </el-col>
                <el-col :span="24" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定期初(上周)的填写任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.week3_value_2" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则4
                            </el-tag>
                            <span style="color: #59a8f9;">【周】先进先出校验(批号)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.week4_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        当周单一医院填写的批号所对应日期，需要大于等于上周该医院填写的批号所对应的日期:若单一医院存在多批号数据。需要大于等于上周该医院填写的多批号中所对应的最大日期
                    </div>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定期初(上周)的填写任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.week4_value_1" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>

        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则5
                            </el-tag>
                            <span style="color: #59a8f9;">【周】库存不动校验(批号)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.week5_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        CRM中填写的批次库存数量，如果连续多周为同样数值，判断为数据异常
                    </div>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定连续多周的具体周数量
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.week5_value_1" multiple placeholder="请选择数据采集任务" size="small"
                            style="width: 100%;">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则6
                            </el-tag>
                            <span style="color: #59a8f9;">【周】无库存异常(机构)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.week6_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        CRM中填写本周批次库存数量后，如果填写内容为无库存,对比上周医院采购总值不为0,提示校验异常
                    </div>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定期初(上周)的填写任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.week6_value_1" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则7
                            </el-tag>
                            <span style="color: #59a8f9;">【周】批号异常 (批号)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.week7_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        CRM中填写本周批次库存数量后，同一机构、同一批号，如果该批号在流向数据(滚动12个月) 中不存在，报异常
                    </div>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则8
                            </el-tag>
                            <span style="color: #59a8f9;">【周】期初校验(批号)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.week8_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        根据流向的医院采购数据，计算本次任务前90天医院采购总量，判断填写的批次数量是否异常:填写数量 >前90天该医院该批次的采购总量，判断为异常
                    </div>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定期初(上周)的填写任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.week8_value_1" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则9
                            </el-tag>
                            <span style="color: #59a8f9;">【月】月理论销售异常(批号)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.month1_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        从第二次月采集任务开始, CRM中填写月批次库存数量后，按照计算公式（月理论销售 = 期初【上次月库存采集任务填写数量,无填写默认为0】+
                        期间采购【BI获取的区间段内数据之和:上次月采集任务当天到本次月采集任务前一天】- 期末【本次月CRM填写数量】），如果计算出的月理论销量 < 0，判断为异常数据; </div>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定期初(上月)的填写任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.month1_value_1" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则10
                            </el-tag>
                            <span style="color: #59a8f9;">【月】先进先出异常(批号)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.month2_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        从第二次月采集任务开始,当次单一医院填写的批号所对应日期，需要大于等于上次该医院填写的批号所对应的日期；若单一医院存在多批号数据，需要大于等于上次该医院填写的多批号中所对应的最大日期
                    </div>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定期初(月度第一周)的填写任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.month2_value_1" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则11
                            </el-tag>
                            <span style="color: #59a8f9;">【月】无库存异常(机构)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.month3_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        从第一次月采集任务开始,CRM中填写本次采集任务的月批次库存数量后，如果填写内容为无库存, 汇总上次月采集任务当天到本次月采集任务的前一天的医院采购总值不为0, 提示校验异常; </div>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定期初(月度第一周)的填写任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.month3_value_1" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则12
                            </el-tag>
                            <span style="color: #59a8f9;">【月】无后续采购异常(机构)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.month4_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        周期为循环三个月, 当前月采集任务汇总为0, N-1月采集任务为0,N-2月采集任务库存不为0,报出异常;</div>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定N-1月的填报任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.month4_value_1" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定N-2月的填报任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.month4_value_2" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则13
                            </el-tag>
                            <span style="color: #59a8f9;">【月】销售异常(机构)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.month5_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        根据流向的医院采购数据，算每个月销售值。根据月填报数据推算月销售是否合理,根据阈值判断是否异常;</div>
                    <div style="color: darkgray;font-size: 15px;line-height: 22px;">
                        期初（上次采集任务填报库存）；</div>
                    <div style="color: darkgray;font-size: 15px;line-height: 22px;">
                        流向的医院采购数据范围: 前一次月采集任务的当天, 到本次月采集任务的前一天;</div>
                    <div style="color: darkgray;font-size: 15px;line-height: 22px;">
                        期末（本次填报库存）；</div>
                    <div style="color: darkgray;font-size: 15px;line-height: 22px;">
                        期初+医院的流向采购数据-期末 = 月销售值</div>
                    <div style="color: darkgray;font-size: 15px;line-height: 22px;">
                        (N月销售)/(N-1月销售) <= 倍数(校验正常)</div>
                    <div style="color: darkgray;font-size: 15px;line-height: 22px;">
                        采集任务开始, 第三个月采集任务开始</div>
                    <div style="color: darkgray;font-size: 15px;line-height: 22px;">
                        (N月销售)/(N-1月销售) <= 倍数(校验正常)</div>
                            <div style="color: darkgray;font-size: 15px;line-height: 22px;">
                                采集任务开始, 第三个月采集任务开始</div>
                            <div style="color: darkgray;font-size: 15px;line-height: 22px;">
                                上月正常: (N月销售)/(N-1月销售) <= 倍数(校验正常)</div>
                                    <div style="color: darkgray;font-size: 15px;line-height: 22px;">
                                        上月异常: (N月销售)/(N-2月销售) <= 倍数(校验正常)</div>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="6">
                        <div style="font-weight: 800;">
                            指定BI流向计算日期(未设上月任务)
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-date-picker v-model="ruleInfo.month5_value_1" type="date" placeholder="选择日期"
                            value-format="yyyy-MM-dd"  size="small">
                        </el-date-picker>
                    </el-col>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="20">
                        <div style="font-weight: 800; color: red;">
                            * 月度采集任务中，无论是否启用规则13， 需指定N-1月的填报任务、N-2月的填报任务、设定销售异常校验的倍数
                        </div>
                    </el-col>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="6">
                        <div style="font-weight: 800;">
                            指定N-1月的填报任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.month5_value_2" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="6">
                        <div style="font-weight: 800;">
                            指定N-2月的填报任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.month5_value_3" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="6">
                        <div style="font-weight: 800;">
                            设定销售异常校验的倍数
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-input v-model="ruleInfo.month5_value_4" placeholder="请输入倍数" size="small"></el-input>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则14
                            </el-tag>
                            <span style="color: #59a8f9;">【月】库存天数异常(机构)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.month6_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        在CRM中, 本次月填报库存值/前90天平均采购值 = 库存天数, 根据阈值判断是否异常; </div>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            设定库存天数的阈值
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-input v-model="ruleInfo.month6_value_1" placeholder="请输入阈值"  size="small" width="100"></el-input>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则15
                            </el-tag>
                            <span style="color: #59a8f9;">【月】期初校验(批号)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.month7_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        第一次月填报数据与前3个月BI流向数据之和进行比对，如果填报数量大于医院3个月的采购总量，判断为异常数据; </div>
                </el-col>
                <el-col :span="23" style="margin-top: 20px;">
                    <el-col :span="4">
                        <div style="font-weight: 800;">
                            指定期初(上月)的填写任务
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <el-select v-model="ruleInfo.month7_value_1" placeholder="请选择数据采集任务" size="small">
                            <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                                :value="item.task_id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-row class="margin padding">
                <el-col :span="24">
                    <el-col :span="14">
                        <div class="grid-content bg-purple-dark">
                            <el-tag effect="dark">
                                规则16
                            </el-tag>
                            <span style="color: #59a8f9;">【周、月】近效期校验(批号)</span>
                        </div>
                    </el-col>
                    <el-col :span="9" style="display: flex; justify-content: end;">
                        <el-switch v-model="ruleInfo.week9_enable" active-value="T" inactive-value="F">
                        </el-switch>
                    </el-col>
                </el-col>
                <el-col :span="23">
                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                        本次填报库存批号产品效期小于 180天</div>
                </el-col>
            </el-row>
        </el-card>
    </el-row>
</template>

<script>
    import collectionBar from '../../../components/collectionBar'
    import http from '../../../APIService/http'
    import moment from "moment";

    export default {
        name: "taskRule",
        data() {
            return {
                tags: ['数据采集任务', '任务概要'],
                subTitle: '',
                territory_name: '',
                channelCheckList: [
                    "INSTITUTION",
                    "HCP",
                    "RETAILSTORE",
                    "DISTRIBUTOR",
                    "CUSTOMTABLE"
                ],
                taskForm: {
                    task_name: '',
                    task_id: '',
                },
                ruleInfo: {
                    week1_enable: "F",
                    week1_value_1: "",
                    week1_value_2: "",
                    week2_enable: "F",
                    week2_value_1: "",
                    week2_value_2: "",
                    week3_enable: "F",
                    week3_value_1: "",
                    week3_value_2: "",
                    week4_enable: "F",
                    week4_value_1: "",
                    week4_value_2: "",
                    week5_enable: "F",
                    week5_value_1: "",
                    week5_value_2: "",
                    week6_enable: "F",
                    week6_value_1: "",
                    week6_value_2: "",
                    week7_enable: "F",
                    week7_value_1: "",
                    week7_value_2: "",
                    week8_enable: "F",
                    week8_value_1: "",
                    week8_value_2: "",
                    week9_enable: "F",
                    week9_value_1: "",
                    week9_value_2: "",

                    month1_enable: "F",
                    month1_value_1: "",
                    month1_value_2: "",
                    month2_enable: "F",
                    month2_value_1: "",
                    month2_value_2: "",
                    month3_enable: "F",
                    month3_value_1: "",
                    month3_value_2: "",
                    month4_enable: "F",
                    month4_value_1: "",
                    month4_value_2: "",
                    month5_enable: "F",
                    month5_value_1: "",
                    month5_value_2: "",
                    month5_value_3: "",
                    month5_value_4: "",
                    month6_enable: "F",
                    month6_value_1: "",
                    month6_value_2: "",
                    month7_enable: "F",
                    month7_value_1: "",
                    month7_value_2: "",
                },
                taskList: []
            }
        },
        components: {
            collectionBar,
        },
        async created() {
            console.log(this.$route.params)
            if (this.$route.params.task_id) {
                this.taskForm.task_id = this.$route.params.task_id
                this.collectProfile = JSON.stringify(this.$route.params)
                localStorage.setItem('collectProfile', this.collectProfile)
            } else {
                this.collectProfile = JSON.parse(localStorage.getItem('collectProfile'))
                this.taskForm.task_id = this.collectProfile.task_id
            }

            await this.getCollectTask()
            this.getTaskRules()
            this.init()
        },
        methods: {
            btnSaveClick() {
                this.saveRules();
            },
            btnBackClick() {
                this.$router.push({ name: 'CollectionHome' })
            },
            init() {
                let loading2 = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        task_id: this.taskForm.task_id
                    }
                    http.post('/wapi/Collect/getCollectInfo', data).then(res => {
                        if (res.success == true) {
                            console.log(res.data)
                            this.subTitle = res.data[0].task_name
                            this.taskForm.task_name = res.data[0].task_name

                            if (this.ruleInfo.week3_value_1 == "")
                                this.ruleInfo.week3_value_1 = res.data[0].start_date;
                        }

                        loading2.close()

                    })
                } catch (e) {
                    loading2.close()
                }

            },
            async getCollectTask() {
                let loading2 = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        reference_obj: this.channelCheckList,
                        task_name: this.task_name,
                        start_date: '',
                        end_date: '',
                        limit: 50,
                        offset: 0
                    }
                    await http.post('/wapi/Collect/getCollectTask', data).then(res => {

                        if (res.success) {
                            if (res.data.result) {
                                this.taskList = res.data.result.filter(item => item.task_id !== this.taskForm.task_id);
                            }

                        } else {
                            Message.error(res.message);
                        }
                    })
                } catch (e) {
                    loading1.close()
                }
            },

            async getTaskRules() {
                let loading2 = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        task_id: this.taskForm.task_id,
                    }
                    await http.post('/crm/web/collection/getTaskRules', data).then(res => {
                        console.log(res)
                        if (res.success && res.data) {
                            console.log('----res.data---')
                            console.log(res)
                            if (res.data.week5_value_1) {
                                res.data.week5_value_1 = res.data.week5_value_1.split(",");
                                console.log(res.data.week5_value_1)
                            }
                            this.ruleInfo = res.data

                        } else {
                            Message.error(res.message);
                        }
                    })
                } catch (e) {
                    console.log(e)
                    loading1.close()
                }
            },
            async saveRules() {
                let loading1 = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    if (this.ruleInfo.week5_value_1) {
                        this.ruleInfo.week5_value_1 = this.ruleInfo.week5_value_1.join(",")
                    }
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        task_id: this.taskForm.task_id,
                        rules: this.ruleInfo
                    }
                    await http.post('/crm/web/collection/saveRules', data).then(res => {

                        loading1.close()
                        if (res.success) {
                            this.$message({
                                type: "success",
                                message: "保存成功"
                            })
                        } else {
                            Message.error(res.message);
                        }
                    })
                } catch (e) {
                    loading1.close()
                }
            }
        },

    }
</script>
<style scoped>

#collection>>>.el-select .el-input {
        width: 300px;
    }
    #collection>>>.el-input{
        width: 300px;
    }
    #collection>>>.el-date-editor.el-input{
        width: 300px;
    }
</style>
<style scoped>
    #collection>>>.el-tag.el-tag--info {
        background: #FF9901;
        color: #FFFFFF;
        border: none;
    }

    #collection>>>.el-tag.el-tag--info .el-tag__close {
        display: none;
    }

    #collection>>>.el-form-item__label {
        font-size: 14px;
        color: black;
        font-weight: bold;
    }

    #collection>>>.collection_star label:after {
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/collection/components/TaskRule.vue